<template>
  <admin-page-shell
    :title="$t('frontend_groovemail_admin_sequences_route_page_title')"
  >
    <server-table
      class="text-center groovemail-user-sequences-table"
      ref="serverTable"
      :url="sequencesListingUrl"
      tableRef="sequencesTable"
      :tableColumns="sequencesTableColumns"
      :tableOptions="sequencesTableOptions"
      tableTitle="frontend_groovemail_admin_sequences_route_page_title"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import { adminUrls } from '@/utils/urls.js';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';

export default {
  middleware: 'auth',
  metaInfo() {
    return {
      title: this.$t('frontend_groovemail_admin_sequences_route_page_title'),
    };
  },

  data() {
    return {
      sequencesListingUrl: adminUrls.adminSequenceUrls.sequenceListing,
      sequencesTableColumns: [
        'broadcast',
        'sequencedetail.name',
        'total_recipients',
      ],
      sequencesTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: ['broadcast'],
        filterable: ['sender_email'],
        headings: {
          broadcast: () =>
            this.$t('frontend_groovemail_admin_sequences_module_name'),
          'sequencedetail.name': () =>
            this.$t('frontend_groovemail_admin_sequences_sequence_name'),
          total_recipients: () =>
            this.$t('frontend_groovemail_admin_campaign_total_recipients'),
        },
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
              self.hideLoader();
            });
        },
        responseAdapter({ data }) {
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },
  
  components: {
    ServerTable,
    AdminPageShell,
  },
  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },
  },
};
</script>

<style lang="scss">
.groovemail-user-sequences-table #gd-server-table-view .VueTables__table th:last-child span {
  display: block;
}
</style>
